<template>
  <teleport to="body">
    <div class="modal-overlay" v-if="show" @click="closeModal">
      <div class="modal-container" @click.stop>
        <h2 class="modal-title">청구 유형 선택</h2>
        <div class="button-grid">
          <button class="claim-type-button" @click="selectClaimType('보장구')">
            <div class="button-content">
              <div class="icon-wrapper">
                <WheelchairIcon :size="50" />
              </div>
              <span class="button-text">보장구</span>
            </div>
          </button>
          <button class="claim-type-button" @click="selectClaimType('산소발생기')">
            <div class="button-content">
              <div class="icon-wrapper">
                <GasCylinderIcon :size="50" />
              </div>
              <span class="button-text">산소발생기</span>
            </div>
          </button>
          <button class="claim-type-button" @click="selectClaimType('당뇨소모성재료')">
            <div class="button-content">
              <div class="icon-wrapper">
                <Diabetes :size="50" />
              </div>
              <span class="button-text">당뇨소모성재료</span>
            </div>
          </button>
        </div>
        <button class="close-button" @click="closeModal">닫기</button>
      </div>
    </div>
  </teleport>
</template>

<script>
import WheelchairIcon from 'vue-material-design-icons/Wheelchair.vue';
import GasCylinderIcon from 'vue-material-design-icons/GasCylinder.vue';
import Diabetes from 'vue-material-design-icons/Diabetes.vue';

export default {
  name: 'ClaimModal',

  emits: ['update:show', 'select-type'],

  components: { WheelchairIcon, GasCylinderIcon, Diabetes },

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    selectClaimType(type) {
      this.$emit('select-type', type);
      this.closeModal();
    },
    
    closeModal() {
      this.$emit('update:show', false);
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        const root = document.documentElement;
        root.classList.toggle('modal-open', newVal);
      }
    }
  }
};
</script>

<style scoped>
html.modal-open,
body.modal-open {
  overflow: hidden;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease-out;
}

.modal-container {
  background: white;
  border-radius: 15px;
  padding: 1.5rem;
  width: 700px;
  min-height: 400px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  transform-origin: bottom center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-title {
  text-align: center;
  margin-bottom: 2.5rem;
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
}

.button-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 50px;
}

.claim-type-button {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 16px;
  padding: 2rem 1.5rem;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-5px);
    border-color: #4dabf7;
    box-shadow: 0 8px 20px rgba(77, 171, 247, 0.15);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, #4dabf7, #228be6);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 14px;
  }

  &:hover::before {
    opacity: 0.05;
  }
}

.button-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  z-index: 2;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  background: #f8f9fa;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  .claim-type-button:hover & {
    background: #e7f5ff;
  }
}

.button-text {
  font-size: 17px;
  font-weight: 500;
  color: #495057;
  transition: color 0.3s ease;

  .claim-type-button:hover & {
    color: #228be6;
  }
}

.close-button {
  width: 30%;
  padding: 15px;
  background: #0f4c5c;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 auto;
  display: block;

  &:hover {
    background: #1a6985;
  }
}
</style>